import { useState, useEffect } from 'react'
import MainTitle from './MainTitle'
import { useParams } from 'react-router-dom'
import useAuth from '../hooks/useAuth'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import { ImageConfig } from './ImageConfig'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'

const Resources = () => {
  const axios = useAxiosPrivate()
  const [showFiles, setShowFiles] = useState([])
  const { setShowLoader, createInfo } = useAuth()

  useEffect(() => {
    getResources()
  }, [])

  const getResources = async () => {
    setShowLoader(true)
    try {
      const response = await axios.get(`/clients/shared-documents`)
    
      if (response.data.result) {
        setShowFiles(response.data.result)
      }
    } catch (error) {}
    setShowLoader(false)
  }

  return (
    <section>
      <MainTitle title="Resources" />
      <section className="w-full bg-white rounded-xl shadow-md py-4 px-4 mb-8">
        <div className="grid grid-cols-4 gap-3">
          {showFiles?.length > 0 && showFiles?.map((item, index) => {
            return (
              <div
                key={index}
                className="grid lg:grid-cols-3 gap-2"
              >
                <div className="flex flex-wrap items-center col-span-2">
                  <img
                    src={
                      ImageConfig[item.name.split('.')[1]] ||
                      ImageConfig['default']
                    }
                    alt=""
                    className="w-14 xl:w-16"
                  />

                  <div className="drop-file-preview__item__info text-sm xl:text-base break-all">
                    <p>{item.name}</p>
                  </div>
                </div>

                <div className="flex items-center justify-end space-x-2">
                  <a href={item.url} target="_blank" rel="noreferrer">
                    <FontAwesomeIcon
                      icon={faDownload}
                      className="w-3 h-3 xl:w-4 xl:h-4 border border-green-200 text-emerald-700 cursor-pointer rounded-full bg-green-200 p-1.5 xl:p-2 hover:border-emerald-500 hover:bg-emerald-500 hover:text-white"/>
                  </a>
                </div>
              </div>
            )
          })}
        </div>
      </section>
    </section>
  )
}

export default Resources
